import React, {useState, useContext, useEffect} from "react";
import AmChartXY from '../../../components/AmChartXY';
import SelectionTool from '../../../components/SelectionTool';
import {SERIES_TYPE_LINE} from "../../../constants/charts";
import {SERIES_TYPE_COLUMN} from "../../../constants/charts";
import {CATEGORY_TYPE_CATEGORY} from "../../../constants/charts";


export default function RealEstateSavingOpportunities({onClick}){
	
	const [chartData, setChartData] = useState([]);
	const [loaded, setLoaded] = useState("false");
	
	useEffect(() => {
		loadChartData();
		setLoaded("true");
	}, [loaded]);
	
	const optionValues = [
		{id:"1", name:"Area"},
		{id:"2", name:"Cost"},
		{id:"3", name:"Capacity"}
	];
	
	const graphs = [{
			name:"Total Area Savings",
			seriesType:SERIES_TYPE_COLUMN,
			yKey:"savings",
			color:"#9ACD00",
			columnWidth:"70"
		},{
			name:"Cumulative Savings",
			seriesType:SERIES_TYPE_LINE,
			yKey:"runningTotal",
			color:"#ffcc00",
			bullets:true,
			additionalAxisAddress:1
		}
	];
					
	const additionalAxes = [
		{opposite:"true", title:"Cummulative Savings"}
	];
	
	
	const loadChartData = () => {
		let tempChartData = [];
		let runningTotal = 0;
		for(let i=2021; i<2031; i++){
			let val = Math.round(Math.random()*1000) + 500;
			runningTotal += val;
			tempChartData.push({
				year:i + "",
				runningTotal:runningTotal,
				savings:val
			})
		}
		setChartData(tempChartData);
		
	};


		
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 50px)",
		flexDirection:"column",
		alignItems:"center",
		justifyContent:"space-around",
		padding:"10px",
		paddingTop:"0px",
		backgroundColor:"white",
		borderRadius:"6px",
		marginLeft:"20px",
		marginTop:"20px"
	};
	
	const chartProps = {
    fontSize:"14px",
    showScrollbar:false,
    showScrollbarY:false,
    showCursor:true,
    showLegend:false,
    marginLeft:0
	};
	
	
	return (
		<div style={thisContainer}>
		
			<AmChartXY
				chartId="realestatehomesavingopportunities"
				width="100%"
				height="400px"
				props={chartProps}
				chartData={chartData}
				chartGraphs={graphs}
				categoryType={CATEGORY_TYPE_CATEGORY}
				categoryKey="year"
				labelsRotate="true"
				xAxisTitle="Total"
				yAxisTitle="Running Total"
				additionalAxes={additionalAxes}
				onClick={onClick}
			>
			</AmChartXY>
			<br/><br/>
			<SelectionTool
				title="Show"
				value="Area"
				values={optionValues}
				dataLoad={loadChartData}
				additionalAxes={additionalAxes}
				categoryKey="year"
			>
			</SelectionTool>
			
		</div>
	);
}